module.exports = __webpack_public_path__ + "static/media/steel-plates@2x.ecf3ed3f.jpg";